import _objectWithoutProperties from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { BaseDisplay } from '@jbrowse/core/pluggableElementTypes/models';
import { getConf } from '@jbrowse/core/configuration';
import { isAbortException, getContainingView, getContainingTrack, getSession, getViewParams, isSelectionContainer, isSessionModelWithWidgets, isFeature, ReactRendering } from '@jbrowse/core/util';
import CompositeMap from '@jbrowse/core/util/compositeMap';
import { getParentRenderProps, getRpcSessionId } from '@jbrowse/core/util/tracks';
import { autorun } from 'mobx';
import { addDisposer, isAlive, types } from 'mobx-state-tree';
// icons
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import { Tooltip } from '../components/BaseLinearDisplay';
import TooLargeMessage from '../components/TooLargeMessage';
import BlockState, { renderBlockData } from './serverSideRenderedBlock';
// stabilize clipid under test for snapshot
function getId(id, index) {
  var isJest = typeof jest === 'undefined';
  return "clip-".concat(isJest ? id : 'jest', "-").concat(index);
}
function getDisplayStr(totalBytes) {
  var displayBp;
  if (Math.floor(totalBytes / 1000000) > 0) {
    displayBp = "".concat(parseFloat((totalBytes / 1000000).toPrecision(3)), " Mb");
  } else if (Math.floor(totalBytes / 1000) > 0) {
    displayBp = "".concat(parseFloat((totalBytes / 1000).toPrecision(3)), " Kb");
  } else {
    displayBp = "".concat(Math.floor(totalBytes), " bytes");
  }
  return displayBp;
}
var minDisplayHeight = 20;
/**
 * #stateModel BaseLinearDisplay
 * extends `BaseDisplay`
 */
function stateModelFactory() {
  return types.compose('BaseLinearDisplay', BaseDisplay, types.model({
    /**
     * #property
     */
    heightPreConfig: types.maybe(types.refinement('displayHeight', types.number, function (n) {
      return n >= minDisplayHeight;
    })),
    /**
     * #property
     * updated via autorun
     */
    blockState: types.map(BlockState),
    /**
     * #property
     */
    userBpPerPxLimit: types.maybe(types.number),
    /**
     * #property
     */
    userByteSizeLimit: types.maybe(types.number)
  })).volatile(function () {
    return {
      currBpPerPx: 0,
      scrollTop: 0,
      message: '',
      featureIdUnderMouse: undefined,
      contextMenuFeature: undefined,
      estimatedRegionStatsP: undefined,
      estimatedRegionStats: undefined
    };
  }).views(function (self) {
    return {
      get height() {
        var _a;
        return (_a = self.heightPreConfig) !== null && _a !== void 0 ? _a : getConf(self, 'height');
      },
      /**
       * #getter
       */
      get blockType() {
        return 'staticBlocks';
      },
      /**
       * #getter
       */
      get blockDefinitions() {
        var blockType = this.blockType;
        var view = getContainingView(self);
        if (!view.initialized) {
          throw new Error('view not initialized yet');
        }
        return view[blockType];
      }
    };
  }).views(function (self) {
    return {
      /**
       * #getter
       * how many milliseconds to wait for the display to
       * "settle" before re-rendering a block
       */
      get renderDelay() {
        return 50;
      },
      /**
       * #getter
       */
      get TooltipComponent() {
        return Tooltip;
      },
      /**
       * #getter
       * returns a string feature ID if the globally-selected object
       * is probably a feature
       */
      get selectedFeatureId() {
        if (isAlive(self)) {
          var _getSession = getSession(self),
            selection = _getSession.selection; // does it quack like a feature?
          if (isFeature(selection)) {
            return selection.id();
          }
        }
        return undefined;
      },
      /**
       * #getter
       * if a display-level message should be displayed instead of the blocks,
       * make this return a react component
       */
      get DisplayMessageComponent() {
        return undefined;
      }
    };
  }).views(function (self) {
    return {
      /**
       * #getter
       * a CompositeMap of `featureId -> feature obj` that
       * just looks in all the block data for that feature
       */
      get features() {
        var featureMaps = [];
        var _iterator = _createForOfIteratorHelper(self.blockState.values()),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var block = _step.value;
            if (block && block.features) {
              featureMaps.push(block.features);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        return new CompositeMap(featureMaps);
      },
      /**
       * #getter
       */
      get featureUnderMouse() {
        var feat = self.featureIdUnderMouse;
        return feat ? this.features.get(feat) : undefined;
      },
      /**
       * #getter
       */
      getFeatureOverlapping: function getFeatureOverlapping(blockKey, x, y) {
        var _a, _b;
        return (_b = (_a = self.blockState.get(blockKey)) === null || _a === void 0 ? void 0 : _a.layout) === null || _b === void 0 ? void 0 : _b.getByCoord(x, y);
      },
      /**
       * #getter
       */
      getFeatureByID: function getFeatureByID(blockKey, id) {
        var _a, _b;
        return (_b = (_a = self.blockState.get(blockKey)) === null || _a === void 0 ? void 0 : _a.layout) === null || _b === void 0 ? void 0 : _b.getByID(id);
      },
      /**
       * #getter
       */
      searchFeatureByID: function searchFeatureByID(id) {
        var ret;
        self.blockState.forEach(function (block) {
          var _a;
          var val = (_a = block === null || block === void 0 ? void 0 : block.layout) === null || _a === void 0 ? void 0 : _a.getByID(id);
          if (val) {
            ret = val;
          }
        });
        return ret;
      },
      /**
       * #getter
       */
      get currentBytesRequested() {
        var _a;
        return ((_a = self.estimatedRegionStats) === null || _a === void 0 ? void 0 : _a.bytes) || 0;
      },
      /**
       * #getter
       */
      get currentFeatureScreenDensity() {
        var _a;
        var view = getContainingView(self);
        return (((_a = self.estimatedRegionStats) === null || _a === void 0 ? void 0 : _a.featureDensity) || 0) * view.bpPerPx;
      },
      /**
       * #getter
       */
      get maxFeatureScreenDensity() {
        return getConf(self, 'maxFeatureScreenDensity');
      },
      /**
       * #getter
       */
      get estimatedStatsReady() {
        return !!self.estimatedRegionStats;
      },
      /**
       * #getter
       */
      get maxAllowableBytes() {
        var _a;
        return self.userByteSizeLimit || ((_a = self.estimatedRegionStats) === null || _a === void 0 ? void 0 : _a.fetchSizeLimit) || getConf(self, 'fetchSizeLimit');
      }
    };
  }).actions(function (self) {
    return {
      /**
       * #action
       */
      setMessage: function setMessage(message) {
        self.message = message;
      },
      afterAttach: function afterAttach() {
        var _this = this;
        // watch the parent's blocks to update our block state when they change,
        // then we recreate the blocks on our own model (creating and deleting to
        // match the parent blocks)
        var blockWatchDisposer = autorun(function () {
          var blocksPresent = {};
          var view = getContainingView(self);
          if (view.initialized) {
            self.blockDefinitions.contentBlocks.forEach(function (block) {
              blocksPresent[block.key] = true;
              if (!self.blockState.has(block.key)) {
                _this.addBlock(block.key, block);
              }
            });
            self.blockState.forEach(function (_, key) {
              if (!blocksPresent[key]) {
                _this.deleteBlock(key);
              }
            });
          }
        });
        addDisposer(self, blockWatchDisposer);
      },
      /**
       * #action
       */
      estimateRegionsStats: function estimateRegionsStats(regions, opts) {
        var _this2 = this;
        if (self.estimatedRegionStatsP) {
          return self.estimatedRegionStatsP;
        }
        var _getSession2 = getSession(self),
          rpcManager = _getSession2.rpcManager;
        var adapterConfig = self.adapterConfig;
        if (!adapterConfig) {
          // A track extending the base track might not have an adapter config
          // e.g. Apollo tracks don't use adapters
          return Promise.resolve({});
        }
        var sessionId = getRpcSessionId(self);
        var params = _objectSpread({
          sessionId: sessionId,
          regions: regions,
          adapterConfig: adapterConfig,
          statusCallback: function statusCallback(message) {
            if (isAlive(self)) {
              _this2.setMessage(message);
            }
          }
        }, opts);
        self.estimatedRegionStatsP = rpcManager.call(sessionId, 'CoreEstimateRegionStats', params).catch(function (e) {
          _this2.setRegionStatsP(undefined);
          throw e;
        });
        return self.estimatedRegionStatsP;
      },
      /**
       * #action
       */
      setRegionStatsP: function setRegionStatsP(p) {
        self.estimatedRegionStatsP = p;
      },
      /**
       * #action
       */
      setRegionStats: function setRegionStats(estimatedRegionStats) {
        self.estimatedRegionStats = estimatedRegionStats;
      },
      /**
       * #action
       */
      clearRegionStats: function clearRegionStats() {
        self.estimatedRegionStatsP = undefined;
        self.estimatedRegionStats = undefined;
      },
      /**
       * #action
       */
      setHeight: function setHeight(displayHeight) {
        if (displayHeight > minDisplayHeight) {
          self.heightPreConfig = displayHeight;
        } else {
          self.heightPreConfig = minDisplayHeight;
        }
        return self.height;
      },
      /**
       * #action
       */
      resizeHeight: function resizeHeight(distance) {
        var oldHeight = self.height;
        var newHeight = this.setHeight(self.height + distance);
        return newHeight - oldHeight;
      },
      /**
       * #action
       */
      setScrollTop: function setScrollTop(scrollTop) {
        self.scrollTop = scrollTop;
      },
      /**
       * #action
       */
      updateStatsLimit: function updateStatsLimit(stats) {
        var view = getContainingView(self);
        if (stats.bytes) {
          self.userByteSizeLimit = stats.bytes;
        } else {
          self.userBpPerPxLimit = view.bpPerPx;
        }
      },
      /**
       * #action
       */
      addBlock: function addBlock(key, block) {
        self.blockState.set(key, BlockState.create({
          key: key,
          region: block.toRegion()
        }));
      },
      /**
       * #action
       */
      setCurrBpPerPx: function setCurrBpPerPx(n) {
        self.currBpPerPx = n;
      },
      /**
       * #action
       */
      deleteBlock: function deleteBlock(key) {
        self.blockState.delete(key);
      },
      /**
       * #action
       */
      selectFeature: function selectFeature(feature) {
        var session = getSession(self);
        if (isSessionModelWithWidgets(session)) {
          var featureWidget = session.addWidget('BaseFeatureWidget', 'baseFeature', {
            view: getContainingView(self),
            track: getContainingTrack(self),
            featureData: feature.toJSON()
          });
          session.showWidget(featureWidget);
        }
        if (isSelectionContainer(session)) {
          session.setSelection(feature);
        }
      },
      /**
       * #action
       */
      clearFeatureSelection: function clearFeatureSelection() {
        var session = getSession(self);
        session.clearSelection();
      },
      /**
       * #action
       */
      setFeatureIdUnderMouse: function setFeatureIdUnderMouse(feature) {
        self.featureIdUnderMouse = feature;
      },
      /**
       * #action
       */
      reload: function reload() {
        ;
        _toConsumableArray(self.blockState.values()).map(function (val) {
          return val.doReload();
        });
      },
      /**
       * #action
       */
      setContextMenuFeature: function setContextMenuFeature(feature) {
        self.contextMenuFeature = feature;
      }
    };
  }).views(function (self) {
    return {
      /**
       * #getter
       * region is too large if:
       * - stats are ready
       * - region is greater than 20kb (don't warn when zoomed in less than that)
       * - and bytes is greater than max allowed bytes or density greater than max density
       */
      get regionTooLarge() {
        var view = getContainingView(self);
        if (!self.estimatedStatsReady || view.dynamicBlocks.totalBp < 20000) {
          return false;
        }
        var bpLimitOrDensity = self.userBpPerPxLimit ? view.bpPerPx > self.userBpPerPxLimit : self.currentFeatureScreenDensity > self.maxFeatureScreenDensity;
        return self.currentBytesRequested > self.maxAllowableBytes || bpLimitOrDensity;
      },
      /**
       * #getter
       * only shows a message of bytes requested is defined, the feature density
       * based stats don't produce any helpful message besides to zoom in
       */
      get regionTooLargeReason() {
        var req = self.currentBytesRequested;
        var max = self.maxAllowableBytes;
        return req && req > max ? "Requested too much data (".concat(getDisplayStr(req), ")") : '';
      }
    };
  }).actions(function (self) {
    var superReload = self.reload;
    return {
      /**
       * #action
       */
      reload: function () {
        var _reload = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var aborter, view, estimatedRegionStats;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                self.setError();
                aborter = new AbortController();
                view = getContainingView(self); // extra check for contentBlocks.length
                // https://github.com/GMOD/jbrowse-components/issues/2694
                if (!(!view.initialized || !view.staticBlocks.contentBlocks.length)) {
                  _context.next = 5;
                  break;
                }
                return _context.abrupt("return");
              case 5:
                _context.prev = 5;
                self.estimatedRegionStatsP = self.estimateRegionsStats(view.staticBlocks.contentBlocks, {
                  signal: aborter.signal
                });
                _context.next = 9;
                return self.estimatedRegionStatsP;
              case 9:
                estimatedRegionStats = _context.sent;
                if (!isAlive(self)) {
                  _context.next = 15;
                  break;
                }
                self.setRegionStats(estimatedRegionStats);
                superReload();
                _context.next = 16;
                break;
              case 15:
                return _context.abrupt("return");
              case 16:
                _context.next = 22;
                break;
              case 18:
                _context.prev = 18;
                _context.t0 = _context["catch"](5);
                console.error(_context.t0);
                self.setError(_context.t0);
              case 22:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[5, 18]]);
        }));
        function reload() {
          return _reload.apply(this, arguments);
        }
        return reload;
      }(),
      afterAttach: function afterAttach() {
        // this autorun performs stats estimation
        //
        // the chain of events calls estimateRegionsStats against the data
        // adapter which by default uses featureDensity, but can also respond
        // with a byte size estimate and fetch size limit (data adapter can
        // define what is too much data)
        addDisposer(self, autorun( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          var _a, aborter, view, statsP, estimatedRegionStats;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                aborter = new AbortController();
                view = getContainingView(self); // extra check for contentBlocks.length
                // https://github.com/GMOD/jbrowse-components/issues/2694
                if (!(!view.initialized || !view.staticBlocks.contentBlocks.length)) {
                  _context2.next = 5;
                  break;
                }
                return _context2.abrupt("return");
              case 5:
                if (!(((_a = self.estimatedRegionStats) === null || _a === void 0 ? void 0 : _a.featureDensity) !== undefined)) {
                  _context2.next = 8;
                  break;
                }
                self.setCurrBpPerPx(view.bpPerPx);
                return _context2.abrupt("return");
              case 8:
                if (!(view.bpPerPx === self.currBpPerPx)) {
                  _context2.next = 10;
                  break;
                }
                return _context2.abrupt("return");
              case 10:
                self.clearRegionStats();
                self.setCurrBpPerPx(view.bpPerPx);
                statsP = self.estimateRegionsStats(view.staticBlocks.contentBlocks, {
                  signal: aborter.signal
                });
                self.setRegionStatsP(statsP);
                _context2.next = 16;
                return statsP;
              case 16:
                estimatedRegionStats = _context2.sent;
                if (isAlive(self)) {
                  self.setRegionStats(estimatedRegionStats);
                }
                _context2.next = 23;
                break;
              case 20:
                _context2.prev = 20;
                _context2.t0 = _context2["catch"](0);
                if (!isAbortException(_context2.t0) && isAlive(self)) {
                  console.error(_context2.t0);
                  self.setError(_context2.t0);
                }
              case 23:
              case "end":
                return _context2.stop();
            }
          }, _callee2, null, [[0, 20]]);
        })), {
          delay: 500
        }));
      }
    };
  }).views(function (self) {
    return {
      /**
       * #method
       */
      regionCannotBeRenderedText: function regionCannotBeRenderedText(_region) {
        return self.regionTooLarge ? 'Force load to see features' : '';
      },
      /**
       * #method
       * @param region -
       * @returns falsy if the region is fine to try rendering. Otherwise,
       *  return a react node + string of text.
       *  string of text describes why it cannot be rendered
       *  react node allows user to force load at current setting
       */
      regionCannotBeRendered: function regionCannotBeRendered(_region) {
        var regionTooLarge = self.regionTooLarge;
        return regionTooLarge ? React.createElement(TooLargeMessage, {
          model: self
        }) : null;
      },
      /**
       * #method
       */
      trackMenuItems: function trackMenuItems() {
        return [];
      },
      /**
       * #method
       */
      contextMenuItems: function contextMenuItems() {
        return self.contextMenuFeature ? [{
          label: 'Open feature details',
          icon: MenuOpenIcon,
          onClick: function onClick() {
            if (self.contextMenuFeature) {
              self.selectFeature(self.contextMenuFeature);
            }
          }
        }] : [];
      },
      /**
       * #method
       */
      renderProps: function renderProps() {
        var view = getContainingView(self);
        return _objectSpread({}, getParentRenderProps(self), {
          notReady: self.currBpPerPx !== view.bpPerPx || !self.estimatedRegionStats,
          rpcDriverName: self.rpcDriverName,
          displayModel: self,
          onFeatureClick: function onFeatureClick(_, featureId) {
            var f = featureId || self.featureIdUnderMouse;
            if (!f) {
              self.clearFeatureSelection();
            } else {
              var feature = self.features.get(f);
              if (feature) {
                self.selectFeature(feature);
              }
            }
          },
          onClick: function onClick() {
            self.clearFeatureSelection();
          },
          // similar to click but opens a menu with further options
          onFeatureContextMenu: function onFeatureContextMenu(_, featureId) {
            var f = featureId || self.featureIdUnderMouse;
            if (!f) {
              self.clearFeatureSelection();
            } else {
              // feature id under mouse passed to context menu
              self.setContextMenuFeature(self.features.get(f));
            }
          },
          onMouseMove: function onMouseMove(_, featureId) {
            self.setFeatureIdUnderMouse(featureId);
          },
          onMouseLeave: function onMouseLeave(_) {
            self.setFeatureIdUnderMouse(undefined);
          },
          onContextMenu: function onContextMenu() {
            self.setContextMenuFeature(undefined);
            self.clearFeatureSelection();
          }
        });
      }
    };
  }).actions(function (self) {
    return {
      /**
       * #method
       */
      renderSvg: function () {
        var _renderSvg = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(opts) {
          var height, id, overrideHeight, view, viewOffsetPx, roundedDynamicBlocks, width, renderings;
          return _regeneratorRuntime().wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                height = self.height, id = self.id;
                overrideHeight = opts.overrideHeight;
                view = getContainingView(self);
                viewOffsetPx = view.offsetPx, roundedDynamicBlocks = view.roundedDynamicBlocks, width = view.width;
                _context4.next = 6;
                return Promise.all(roundedDynamicBlocks.map( /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(block) {
                    var blockState, cannotBeRenderedReason, _renderBlockData, rpcManager, renderArgs, renderProps, rendererType;
                    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                      while (1) switch (_context3.prev = _context3.next) {
                        case 0:
                          blockState = BlockState.create({
                            key: block.key,
                            region: block
                          }); // regionCannotBeRendered can return jsx so look for plaintext
                          // version, or just get the default if none available
                          cannotBeRenderedReason = self.regionCannotBeRenderedText(block) || self.regionCannotBeRendered(block);
                          if (!cannotBeRenderedReason) {
                            _context3.next = 4;
                            break;
                          }
                          return _context3.abrupt("return", [block, {
                            reactElement: React.createElement(React.Fragment, null, React.createElement("rect", {
                              x: 0,
                              y: 0,
                              width: width,
                              height: 20,
                              fill: "#aaa"
                            }), React.createElement("text", {
                              x: 0,
                              y: 15
                            }, cannotBeRenderedReason))
                          }]);
                        case 4:
                          _renderBlockData = renderBlockData(blockState, self), rpcManager = _renderBlockData.rpcManager, renderArgs = _renderBlockData.renderArgs, renderProps = _renderBlockData.renderProps, rendererType = _renderBlockData.rendererType;
                          _context3.t0 = block;
                          _context3.next = 8;
                          return rendererType.renderInClient(rpcManager, _objectSpread({}, renderArgs, renderProps, {
                            viewParams: getViewParams(self, true),
                            exportSVG: opts,
                            theme: opts.theme || renderProps.theme
                          }));
                        case 8:
                          _context3.t1 = _context3.sent;
                          return _context3.abrupt("return", [_context3.t0, _context3.t1]);
                        case 10:
                        case "end":
                          return _context3.stop();
                      }
                    }, _callee3);
                  }));
                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }()));
              case 6:
                renderings = _context4.sent;
                return _context4.abrupt("return", React.createElement(React.Fragment, null, renderings.map(function (_ref3, index) {
                  var _ref4 = _slicedToArray(_ref3, 2),
                    block = _ref4[0],
                    rendering = _ref4[1];
                  var offsetPx = block.offsetPx,
                    widthPx = block.widthPx;
                  var offset = offsetPx - viewOffsetPx;
                  var clipid = getId(id, index);
                  return React.createElement(React.Fragment, {
                    key: "frag-".concat(index)
                  }, React.createElement("defs", null, React.createElement("clipPath", {
                    id: clipid
                  }, React.createElement("rect", {
                    x: 0,
                    y: 0,
                    width: widthPx,
                    height: overrideHeight || height
                  }))), React.createElement("g", {
                    transform: "translate(".concat(offset, " 0)")
                  }, React.createElement("g", {
                    clipPath: "url(#".concat(clipid, ")")
                  }, React.createElement(ReactRendering, {
                    rendering: rendering
                  }))));
                })));
              case 8:
              case "end":
                return _context4.stop();
            }
          }, _callee4);
        }));
        function renderSvg(_x) {
          return _renderSvg.apply(this, arguments);
        }
        return renderSvg;
      }()
    };
  }).preProcessSnapshot(function (snap) {
    if (!snap) {
      return snap;
    }
    // rewrite "height" from older snapshots to "heightPreConfig", this allows
    // us to maintain a height "getter" going forward
    // @ts-ignore
    var height = snap.height,
      rest = _objectWithoutProperties(snap, ["height"]);
    return _objectSpread({
      heightPreConfig: height
    }, rest);
  }).postProcessSnapshot(function (self) {
    // xref https://github.com/mobxjs/mobx-state-tree/issues/1524 for Omit
    var r = self;
    var blockState = r.blockState,
      rest = _objectWithoutProperties(r, ["blockState"]);
    return rest;
  });
}
export var BaseLinearDisplay = stateModelFactory();